import { Group, Stack } from '@mantine/core';
import { TextSkeleton } from '@repo/foundations';
import { memo } from 'react';
import { SlackEmbedPreviewBody } from './SlackEmbedPreviewBody';

export const SlackEmbedPreviewSkeleton = memo(() => (
	<SlackEmbedPreviewBody>
		<Group spacing="sm" noWrap>
			<Stack spacing={0}>
				<TextSkeleton size="sm" />
				<TextSkeleton size="xs" />
			</Stack>
		</Group>
	</SlackEmbedPreviewBody>
));
